<div class="list-contract-comp-wrapper" *ngIf="contentLoaded && data">
  <app-header-hifpt></app-header-hifpt>
  <div class="body-wrapper">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8 col-md-8 col-sm-12 col-xs-12">
          <div class="col-wrapper">
            <div class="title">
              <span class="position-relative">Nâng cấp dịch vụ</span>
            </div>

            <div
              class="list-upgraded list-item-wrapper"
              *ngIf="
                data.upgraded_contract.list_contract &&
                data.upgraded_contract.list_contract.length > 0
              "
            >
              <div class="sub-title">{{ data.upgraded_contract.text }}</div>
              <div class="list-item">
                <div
                  class="item"
                  *ngFor="let item of data.upgraded_contract.list_contract"
                >
                  <div class="item-wrapper">
                    <div class="contract-wrapper">
                      <div class="contract-title">Số hợp đồng</div>
                      <div class="contract-no">
                        <div class="contract">{{ item.contract_no }}</div>
                        <div
                          class="status"
                          [ngClass]="item.status.code.toLowerCase()"
                        >
                          {{ item.status.text }}
                        </div>
                      </div>
                    </div>
                    <div class="customer-wrapper">
                      <div class="info">
                        <div class="name">{{ item.full_name }}</div>
                        <div class="phone">{{ item.phone_nb }}</div>
                      </div>
                      <div class="address">
                        {{ item.address }}
                      </div>
                    </div>
                    <div class="button-wrapper" *ngIf="item.status.is_retry === 1">
                      <button
                        (click)="gotoDetail(item.contract_no_encode)"
                      ><span>Thanh toán ngay</span>
                      </button>
                    </div>
                    <div class="button-wrapper" *ngIf="item.status.is_retry === 0">
                      <button class="sub-color"
                        (click)="checkUpdated(item)"
                      ><span>Xem chi tiết</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="list-not-upgrade list-item-wrapper"
              *ngIf="
                data.not_upgraded_contract.list_contract &&
                data.not_upgraded_contract.list_contract.length > 0
              "
            >
              <div class="sub-title">{{ data.not_upgraded_contract.text }}</div>
              <div class="list-item">
                <div
                  class="item"
                  *ngFor="let item of data.not_upgraded_contract.list_contract"
                >
                  <div class="item-wrapper">
                    <div class="contract-wrapper">
                      <div class="contract-title">Số hợp đồng</div>
                      <div class="contract-no">
                        <div class="contract">{{ item.contract_no }}</div>
                      </div>
                    </div>
                    <div class="customer-wrapper">
                      <div class="info">
                        <div class="name">{{ item.full_name }}</div>
                        <div class="phone">{{ item.phone_nb }}</div>
                      </div>
                      <div class="address">
                        {{ item.address }}
                      </div>
                    </div>
                    <div class="button-wrapper">
                      <button
                        *ngIf="item.status.code.toLowerCase() === 'valid'"
                        (click)="gotoDetail(item.contract_no_encode)"
                      >
                        <img
                          src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/upload.svg"
                          alt=""
                          width="auto"
                          height="auto"
                        /><span>{{ item.status.text }}</span>
                      </button>
                      <button
                        *ngIf="item.status.code.toLowerCase() === 'invalid'"
                        (click)="handleAdvise(item)"
                      >
                        <img
                          src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/support.svg"
                          alt=""
                          width="auto"
                          height="auto"
                        /><span>{{ item.status.text }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer-hifpt></app-footer-hifpt>
</div>
<app-spinner-layout></app-spinner-layout>
